import { useEffect, useMemo, useState } from "react";

const LibraTranslate = ({ text, lang = "en" }: any) => {
    const [translatedText, setTranslatedText] = useState<string | null>(text);

    const translateResponse = async (lang = 'en', text: string) => {
        try {
            const response = await fetch('http://85.215.128.124:5000/translate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    q: text,
                    source: 'en',
                    target: localStorage?.getItem("language") ?? lang,
                    format: 'text',
                    alternatives: 3,
                    api_key: ""
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            return data.translatedText;
        } catch (error) {
            console.error('Translation error:', error);
            return text;
        }
    }

    const testFunction = async () => {
        if (text && text !== "") {
            const data = await translateResponse(lang, text);
            setTranslatedText(data);
        }
    }
    useEffect(() => {
        testFunction()
    }, [text, lang])



    return <>
        {translatedText}
    </>
}

export default LibraTranslate;